import eventcenter from '@/big-common/util/eventcenter'

export default eventcenter
